module.exports = __webpack_public_path__ + "assets/img/66_519.73c43da0.jpg";